import { api } from '@/lib/api'
import type { CreateTeamRequest, Team, TeamMember, UpdateTeamRequest } from './types'

export async function listTeams(activeOnly = true): Promise<Team[]> {
  const r = await api.get<{ teams: Team[] }>('/api/teams', { params: { activeOnly } })
  return r.data.teams
}

/** Returns teams the calling user belongs to (direct + descendants per hierarchy). */
export async function listMyTeams(): Promise<Team[]> {
  const r = await api.get<{ teams: Team[] }>('/api/teams/me')
  return r.data.teams
}

export async function createTeam(payload: CreateTeamRequest): Promise<Team> {
  const r = await api.post<Team>('/api/teams', payload)
  return r.data
}

export async function updateTeam(id: number, payload: UpdateTeamRequest): Promise<Team> {
  const r = await api.put<Team>(`/api/teams/${id}`, payload)
  return r.data
}

export async function deactivateTeam(id: number): Promise<void> {
  await api.delete(`/api/teams/${id}`)
}

export async function listMembers(teamId: number): Promise<TeamMember[]> {
  const r = await api.get<TeamMember[]>(`/api/teams/${teamId}/members`)
  return r.data
}

export async function addMember(teamId: number, userId: number): Promise<void> {
  await api.post(`/api/teams/${teamId}/members`, { userId })
}

export async function removeMember(teamId: number, userId: number): Promise<void> {
  await api.delete(`/api/teams/${teamId}/members/${userId}`)
}
